import { useEffect, useState } from "react";
import { fetchReferences, searchReferences } from "../../api/application/reference";
import type { PaginationOptions } from "../../api/domain/pagination";
import type { Reference } from "../../api/infrastructure/reference.formatter";
import { apiRequestWrapper } from "../../api/shared/http-client";

export default function useGetReferences({ preloadData = true }: { preloadData?: boolean } = {}) {
  const [references, setReferences] = useState<Reference[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetch = async (options: PaginationOptions) => {
    setLoading(true);
    await apiRequestWrapper(async () => {
      const result = await fetchReferences(options);
      setReferences(result.data);
      setTotal(result.pagination?.total ?? result.data.length);
    });
    setLoading(false);
  };

  const search = async (query: string) => {
    await apiRequestWrapper(async () => {
      const result = await searchReferences(query);
      setReferences(result);
      setTotal(result.length);
    });
  };

  useEffect(() => {
    if (!preloadData) return;
    fetch({ limit: 10, page: 1 });
  }, []);

  return {
    references,
    total,
    refreshReferences: fetch,
    searchReferences: search,
    loadingReferences: loading,
  };
}
